import { render, staticRenderFns } from "./Angebot.vue?vue&type=template&id=674003d6"
import script from "./Angebot.vue?vue&type=script&lang=js"
export * from "./Angebot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports